var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"imageClass"},[_c('img',{attrs:{"src":require("@/assets/img/logo_len.png")}})]),_c('div',{staticClass:"mainTitle"},[_vm._v("版权信息：泰坦云控出品程序，拥有自主知识产权，盗版必究。")])])
}]

export { render, staticRenderFns }